import {Pipe, PipeTransform} from '@angular/core';
import {Profile} from '@models';

@Pipe({
	      name: 'profileFilter',
	      standalone: true
      })
export class ProfileFilterPipe implements PipeTransform {
	transform(profiles: Profile[], filter?: string): Profile[] {
		if (!profiles || !filter) {
			return profiles;
		} else {
			filter = filter.toLowerCase().trim();
			return profiles.filter(profile => profile.username.toLowerCase().includes(filter + '') ||
			                                  profile.email.toLowerCase().includes(filter + '') ||
			                                  (profile.scope).toLowerCase().includes(filter + '') ||
			                                  (profile.emailVerified ? 'verified' : 'not verified').toLowerCase().includes(filter + '')
			);
		}
	}
}
